// extracted by mini-css-extract-plugin
module.exports = {"selectTag":"NewHome_selectTag__3zo0q","noPadding":"NewHome_noPadding__zNEn_"};